import { LONG_GAP_THRESHOLD, SHORT_GAP_THRESHOLD } from './constants.js';
import { daysBetween } from './curve.js';
/**
 * Computes the engagement level based on onboarding status and time since last session.
 */
export function computeEngagementLevel(hasOnboarded, lastSessionCloseAt, now) {
    if (!hasOnboarded)
        return 'new';
    if (!lastSessionCloseAt)
        return 'daily';
    const gap = daysBetween(lastSessionCloseAt, now);
    if (gap <= SHORT_GAP_THRESHOLD)
        return 'daily';
    if (gap <= LONG_GAP_THRESHOLD)
        return 'short-gap';
    return 'long-gap';
}
/** Display configuration per engagement level. */
export const ENGAGEMENT_CONFIG = {
    new: {
        level: 'new',
        maxQueueVisible: 0,
        showTimeline: false,
        showCategories: false,
    },
    daily: {
        level: 'daily',
        maxQueueVisible: 5,
        showTimeline: true,
        showCategories: true,
    },
    'short-gap': {
        level: 'short-gap',
        maxQueueVisible: 3,
        showTimeline: false,
        showCategories: true,
    },
    'long-gap': {
        level: 'long-gap',
        maxQueueVisible: 0,
        showTimeline: false,
        showCategories: false,
    },
};
//# sourceMappingURL=engagement.js.map